import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { UJE_PAYMENT_DOCUMENT } from "./apiRoutes";

interface mutateProps {
  communityId: string;
  parkId: string;
  data: FieldValues
}

const mutateUpdateParkPayment = async ({ data, communityId, parkId }: mutateProps) => {
  return await axiosAuth.put(`${UJE_PAYMENT_DOCUMENT(communityId)}/parked/${parkId}`, data);
};

const useUpdateParkPaymentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateParkPayment,
    ...queryParams,
  });

export default useUpdateParkPaymentMutation;
